import user from '../services/user';
import { request } from "../services";

interface Returning {
  isAdm: boolean;
  userId: number;
}

type toSend = {
  page: string;
  action: string;
  user_id: number;
  row_id?: number;
  bta_documents_id?: number;
};

export default async function checkIsAdmin(pathname: string, action: string): Promise<Returning> {
    // console.log("MY action IS ADMIN pathname action ", pathname, action);

  let access;
  const currentRoute = '/' + pathname.split("/").filter(Boolean).slice(-2).join("/");
  const page = currentRoute.split("/").filter(Boolean).slice(-1).join("/");

  const sessionData = sessionStorage.getItem(`session_data_${currentRoute}`);
  const sessionDataRaw = sessionData ? JSON.parse(sessionData) : null;

  const tokInfo = user.decode();
  const userID: number = action === 'add' ? 0 : tokInfo?.id ?? 0;
  const rowID: number = action === 'add' ? 0 : sessionDataRaw?.id ?? 0;
  const btaDocumentID: number = action === 'add' ? 0 : sessionDataRaw?.bta_documents_id ?? 0;

  const data: toSend = {
    page: page,
    action: action,
    user_id: userID,
    row_id: rowID,
    bta_documents_id: btaDocumentID
  };
    // console.log("MY action IS ADMIN data", data);

  try {
    const response = await request(`/service/check-access-rights-admin`, {
      method: "post",
      cancelTokenKey: "isadmin",
      body: data,
    });

    // console.log("MY action IS ADMIN response", response);

    access = response?.Access;
  } catch (error) {
    console.error("checkIsAdmin error", error);
    access = false;
  }
    // console.log("MY action IS ADMIN response access ", access);

    return { isAdm: access, userId: userID };

}
